import { cx } from '@freightapi/ui'
import { Link } from '@tanstack/react-router'
import { useSignI18n } from '../../lib/locale'
import { useSubmissionQueue } from '../../lib/offline-queue'

/**
 * How many submissions this phone is still carrying (M2-08, scope 4).
 *
 * It sits in the header of every screen rather than in the flow, because the whole point of the
 * queue is that a driver may have walked away from the flow: the app was closed in a tunnel, the
 * link was finished on another device, the next errand was started. The number is the count of
 * captures that have not reached the API — the badge disappears the moment it is nothing.
 *
 * It turns red when something stopped. A queue that is merely waiting is normal and the colour
 * says so; a queue that needs a person must not look the same.
 */
export function QueueBadge() {
  const { t } = useSignI18n()
  const { outstanding, attention, ready } = useSubmissionQueue()

  if (!ready || outstanding === 0) return null

  return (
    <Link
      to="/queue"
      data-queue-badge={outstanding}
      data-queue-attention={attention > 0 ? 'true' : 'false'}
      aria-label={t('queue.badge', { count: outstanding })}
      className={cx(
        'inline-flex min-h-touch shrink-0 items-center gap-1 rounded-card px-2 font-medium text-caption',
        attention > 0 ? 'bg-danger/15 text-danger' : 'bg-brand-50 text-brand-700',
      )}
    >
      <span
        aria-hidden="true"
        className={cx('size-2 rounded-full', attention > 0 ? 'bg-danger' : 'bg-brand-600')}
      />
      <span aria-hidden="true">{outstanding}</span>
    </Link>
  )
}
